import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

class UIModalComponent extends React.Component {
  render() {
    const {
      title,
      body,
      onClose,
      onSave,
      size,
      show,
      proceedText,
      cancelText,
    } = this.props;
    return (
      <Modal size={size} show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>{body}</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant="primary" onClick={onSave}>
            {proceedText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(UIModalComponent);
